import {useEffect, useState} from 'react'
// Types
import type {CategoryAd} from '../../types/ballot'
// Styles
import styles from './question-ad-image.module.scss'

interface QuestionAdImageProps {
  ad: CategoryAd | null
  adPathTypeOverride?: 'desktop' | 'mobile' | null
  adHeightOverride?: string | number
}

const QuestionAdImage = ({
  ad,
  adPathTypeOverride = null,
  adHeightOverride,
}: QuestionAdImageProps) => {
  const [imageSource , setImageSource] = useState(() => {
    let newImageSource = ad?.desktop_image_path
    if (adPathTypeOverride === 'mobile')
      newImageSource = ad?.mobile_image_path

    return newImageSource
  })

  useEffect(() => {
    let newImageSource = ad?.desktop_image_path
    if (adPathTypeOverride === 'mobile')
      newImageSource = ad?.mobile_image_path

    setImageSource(newImageSource)
  }, [ad])

  return ad
    ? <div className={`
      ${styles['__container']}
      ${styles['--is-photo-voting']}
    `}>
      <a
        href={ad.website_link}
        target='_blank'
        className={`
          ${styles['question-ad']}
          ${styles['--is-photo-voting']}
        `}
        rel="noreferrer"
      >
        <img
          src={imageSource}
          // alt='sponsor image'
          style={{height: adHeightOverride ? adHeightOverride : undefined}}
        />
      </a>
    </div>
    : null
}

export default QuestionAdImage
